module.exports = __webpack_public_path__ + "img/whatsapp-icon.2f33a6dc.svg";